<template>
    <div>
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field
                    v-model="data[leg].input_viaFlight_FlightNo"
                    class="uppercase"
                    name="input_FlightNo"
                    :rules ="[
                        showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_viaFlight_FlightNo, data[leg].input_FlightTypeTab === 1),
                        rules.min(2, data[leg].input_viaFlight_FlightNo),
                        rules.max(8, data[leg].input_viaFlight_FlightNo),
                        rules.isFlightNo(data[leg].input_viaFlight_FlightNo),
                    ]"
                    maxlength="8"
                    counter
                    prepend-icon="mdi-numeric"
                    clearable
                    :hint="'ATC Call Sign: ' + data[leg].input_viaFlight_AtcCallSign"
                    persistent-hint
                    @input="onChange_FlightNo">
                    <template v-slot:label>
                        <p>
                        Flight# <span style="color: red; font-size: 1.4rem;">*</span>
                        </p>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="4">
                <v-combobox
                    v-model="data[leg].input_viaFlight_AirportDeparture"
                    class="uppercase"
                    :items="get_Airports"
                    :rules ="[
                        showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_viaFlight_AirportDeparture, data[leg].input_FlightTypeTab === 1),
                    ]"
                    item-value="iataCode"
                    item-text="iataCode"
                    prepend-icon="mdi-airplane-takeoff"
                    clearable
                    @input="onChange_viaFlight_Departure(); onChange_checkForOvernight(); onChange_fillBlockTimes('input_AB_Time_Departure_Scheduled')">
                    <template v-slot:label>
                        <p>
                        Airport Departure <span style="color: red; font-size: 1.4rem;">*</span>
                        </p>
                    </template>
                </v-combobox>
            </v-col>

            <v-col cols="12" sm="4">
                <v-combobox
                    v-model="data[leg].input_viaFlight_AirportVia"
                    class="uppercase"
                    :items="get_Airports"
                    :rules ="[
                        showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_viaFlight_AirportVia, data[leg].input_FlightTypeTab === 1),
                    ]"
                    item-value="iataCode"
                    item-text="iataCode"
                    prepend-icon="mdi-airplane-landing"
                    clearable
                    @input="onChange_viaFlight_AirportVia(); onChange_checkForOvernight(); onChange_fillBlockTimes('input_AB_Time_Departure_Scheduled')">
                    <template v-slot:label>
                        <p>
                        Airport VIA <span style="color: red; font-size: 1.4rem;">*</span>
                        </p>
                    </template>
                </v-combobox>
            </v-col>

            <v-col cols="12" sm="4">
                <v-combobox
                    v-model="data[leg].input_viaFlight_AirportDestination"
                    class="uppercase"
                    :items="get_Airports"
                    :rules ="[
                        showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_viaFlight_AirportDestination, data[leg].input_FlightTypeTab === 1),
                    ]"
                    item-value="iataCode"
                    item-text="iataCode"
                    prepend-icon="mdi-airplane-landing"
                    clearable
                    @input="onChange_viaFlight_Destination(); onChange_checkForOvernight(); onChange_fillBlockTimes('input_BC_Time_Departure_Scheduled')">
                    <template v-slot:label>
                        <p>
                        Airport Destination <span style="color: red; font-size: 1.4rem;">*</span>
                        </p>
                    </template>
                </v-combobox>
            </v-col>
        </v-row>

        <!-- >>> Row - AB -->
        <div style="margin-top: 60px;">
            <p class="font-weight-bold mb-0">
            AB Times
            </p>
            <v-row v-if="get_flights_OCCMode">
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_AB_Time_Departure_Actual"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="AB Time Departure (Actual)"
                        @input="onChange_ActualTime('AB_DEPARTURE')" />
                </v-col>

                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_AB_Time_Arrival_Actual"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="AB Time Arrival (Actual)"
                        @input="onChange_ActualTime('AB_ARRIVAL')" />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_AB_Time_Departure_Scheduled"
                        :rules ="[
                            showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_AB_Time_Departure_Scheduled, data[leg].input_FlightTypeTab === 1),
                        ]"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        @input="onChange_checkForOvernight(); onChange_fillBlockTimes('input_AB_Time_Departure_Scheduled')">
                        <template v-slot:label>
                            <p>
                            AB Time Departure (Scheduled) <span style="color: red; font-size: 1.4rem;">*</span>
                            </p>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_AB_Time_Arrival_Scheduled"
                        :rules ="[
                            showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_AB_Time_Arrival_Scheduled, data[leg].input_FlightTypeTab === 1),
                        ]"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        @input="onChange_checkForOvernight(); onChange_autoFillTurnaroundTime('input_AB_Time_Arrival_Scheduled', leg)">
                        <template v-slot:label>
                            <p>
                            AB Time Arrival (Scheduled) <span style="color: red; font-size: 1.4rem;">*</span>
                            </p>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-text-field
                        v-model="data[leg].input_AB_Slot_Departure"
                        :tabindex="get_flights_OCCMode ? '-1' : ''"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="AB Slot Departure"
                        :hint="createMissingSlotString('input_viaFlight_AirportDeparture', 'input_AB_Slot_Departure', 'input_AB_Time_Departure_Scheduled')"
                        persistent-hint
                        @change="onChange_setSlotRequestStatus('input_AB_Departure_SlotStatus', $refs['input_AB_Departure_SlotStatus'])" />
                </v-col>

                <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div multiple v-on="on">
                                <v-checkbox
                                    v-model="input_Delete_AB_Slot_Departure"
                                    off-icon="mdi-trash-can-outline"
                                    on-icon="mdi-trash-can-outline"
                                    @change="v => onChange_deleteForAll(leg, v, 'AB_SLOT_DEPARTURE', 'input_AB_Slot_Departure')" />
                            </div>
                        </template>
                        <span>Delete for all</span>
                    </v-tooltip>
                </v-col>

                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-text-field
                        v-model="data[leg].input_AB_Slot_Arrival"
                        :tabindex="get_flights_OCCMode ? '-1' : ''"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="AB Slot Arrival"
                        :hint="createMissingSlotString('input_viaFlight_AirportVia', 'input_AB_Slot_Arrival', 'input_AB_Time_Arrival_Scheduled')"
                        persistent-hint
                        @change="onChange_setSlotRequestStatus('input_AB_Arrival_SlotStatus', $refs['input_AB_Arrival_SlotStatus'])" />
                </v-col>

                <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div multiple v-on="on">
                                <v-checkbox
                                    v-model="input_Delete_AB_Slot_Arrival"
                                    off-icon="mdi-trash-can-outline"
                                    on-icon="mdi-trash-can-outline"
                                    @change="v => onChange_deleteForAll(leg, v, 'AB_SLOT_ARRIVAL', 'input_AB_Slot_Arrival')" />
                            </div>
                        </template>
                        <span>Delete for all</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-select
                        ref="input_AB_Departure_SlotStatus"
                        v-model="data[leg].input_AB_Departure_SlotStatus"
                        :items="items_slotRequestStatus"
                        prepend-icon="mdi-send-check"
                        class="slotRequestStatus">
                        <template v-slot:label>
                            <p>
                            AB Departure Slot Request Status
                            </p>
                        </template>
                    </v-select>
                </v-col>

                <v-col v-if="showDeleteCheckbox" cols="12" sm="1" />

                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-select
                        ref="input_AB_Arrival_SlotStatus"
                        v-model="data[leg].input_AB_Arrival_SlotStatus"
                        :items="items_slotRequestStatus"
                        prepend-icon="mdi-send-check"
                        class="slotRequestStatus">
                        <template v-slot:label>
                            <p>
                            AB Arrival Slot Request Status
                            </p>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
        </div>
        <!-- <<< Row - AB -->

        <!-- >>> Row - BC -->
        <div style="margin-top: 40px;">
            <p class="font-weight-bold mb-0">
            BC Times
            </p>
            <v-row v-if="get_flights_OCCMode">
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_BC_Time_Departure_Actual"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="BC Time Departure (Actual)"
                        @input="onChange_ActualTime('BC_DEPARTURE')" />
                </v-col>

                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_BC_Time_Arrival_Actual"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="BC Time Arrival (Actual)"
                        @input="onChange_ActualTime('BC_ARRIVAL')" />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_BC_Time_Departure_Scheduled"
                        :rules ="[
                            showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_BC_Time_Departure_Scheduled, data[leg].input_FlightTypeTab === 1),
                        ]"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        @input="onChange_checkForOvernight(); onChange_fillBlockTimes('input_BC_Time_Departure_Scheduled')">
                        <template v-slot:label>
                            <p>
                            BC Time Departure (Scheduled) <span style="color: red; font-size: 1.4rem;">*</span>
                            </p>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="data[leg].input_BC_Time_Arrival_Scheduled"
                        :rules ="[
                            showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_BC_Time_Arrival_Scheduled, data[leg].input_FlightTypeTab === 1),
                        ]"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        @input="onChange_checkForOvernight(); onChange_autoFillTurnaroundTime('input_BC_Time_Arrival_Scheduled', leg)">
                        <template v-slot:label>
                            <p>
                            BC Time Arrival (Scheduled) <span style="color: red; font-size: 1.4rem;">*</span>
                            </p>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-text-field
                        v-model="data[leg].input_BC_Slot_Departure"
                        :tabindex="get_flights_OCCMode ? '-1' : ''"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="BC Slot Departure"
                        :hint="createMissingSlotString('input_viaFlight_AirportVia', 'input_BC_Slot_Departure', 'input_BC_Time_Departure_Scheduled')"
                        persistent-hint
                        @change="onChange_setSlotRequestStatus('input_BC_Departure_SlotStatus', $refs['input_BC_Departure_SlotStatus'])" />
                </v-col>

                <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div multiple v-on="on">
                                <v-checkbox
                                    v-model="input_Delete_BC_Slot_Departure"
                                    off-icon="mdi-trash-can-outline"
                                    on-icon="mdi-trash-can-outline"
                                    @change="v => onChange_deleteForAll(leg, v, 'BC_SLOT_DEPARTURE', 'input_BC_Slot_Departure')" />
                            </div>
                        </template>
                        <span>Delete for all</span>
                    </v-tooltip>
                </v-col>

                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-text-field
                        v-model="data[leg].input_BC_Slot_Arrival"
                        :tabindex="get_flights_OCCMode ? '-1' : ''"
                        prepend-icon="mdi-clock-time-four-outline"
                        type="time"
                        label="BC Slot Arrival"
                        :hint="createMissingSlotString('input_viaFlight_AirportDestination', 'input_BC_Slot_Arrival', 'input_BC_Time_Arrival_Scheduled')"
                        persistent-hint
                        @change="onChange_setSlotRequestStatus('input_BC_Arrival_SlotStatus', $refs['input_BC_Arrival_SlotStatus'])" />
                </v-col>

                <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div multiple v-on="on">
                                <v-checkbox
                                    v-model="input_Delete_BC_Slot_Arrival"
                                    off-icon="mdi-trash-can-outline"
                                    on-icon="mdi-trash-can-outline"
                                    @change="v => onChange_deleteForAll(leg, v, 'BC_SLOT_ARRIVAL', 'input_BC_Slot_Arrival')" />
                            </div>
                        </template>
                        <span>Delete for all</span>
                    </v-tooltip>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-select
                        ref="input_BC_Departure_SlotStatus"
                        v-model="data[leg].input_BC_Departure_SlotStatus"
                        :items="items_slotRequestStatus"
                        prepend-icon="mdi-send-check"
                        class="slotRequestStatus">
                        <template v-slot:label>
                            <p>
                            BC Departure Slot Request Status
                            </p>
                        </template>
                    </v-select>
                </v-col>

                <v-col v-if="showDeleteCheckbox" cols="12" sm="1" />

                <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                    <v-select
                        ref="input_BC_Arrival_SlotStatus"
                        v-model="data[leg].input_BC_Arrival_SlotStatus"
                        :items="items_slotRequestStatus"
                        prepend-icon="mdi-send-check"
                        class="slotRequestStatus">
                        <template v-slot:label>
                            <p>
                            BC Arrival Slot Request Status
                            </p>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
        </div>
        <!-- <<< Row - BC -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../../main';

    export default {
        name: 'SdrStep3RouteconfigViaflight',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create'
            data: Object, // entire 'crud' Object
            leg: String, // "firstLeg", "secondLeg"
            rules: Object, // entire rules Object
            onChange_FlightNo: Function, //
            onChange_viaFlight_AirportDeparture: Function,
            onChange_viaFlight_AirportDestination: Function,
            onChange_checkForOvernight: Function,
            onChange_fillBlockTimes: Function,
            onChange_autoFillTurnaroundTime: Function,
            onChange_ActualTime: Function,
            createMissingSlotString: Function,
            showDeleteCheckbox: Boolean,
            onChange_setSlotRequestStatus: Function

        }, // eo props{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                input_Delete_AB_Slot_Departure: false,
                input_Delete_AB_Slot_Arrival: false,
                input_Delete_BC_Slot_Departure: false,
                input_Delete_BC_Slot_Arrival: false,
                items_slotRequestStatus: [
					{
						value: 'confirmed',
						text: 'Confirmed'
					},
					{
						value: 'pending',
						text: 'Pending'
					},
					{
						value: 'offered',
						text: 'Offered'
					},
					{
						value: 'refused',
						text: 'Refused'
					},
					{
						value: 'cancelled',
						text: 'Cancelled'
					}
				]
            };

        }, // eo data{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Airports',
                'get_flights_OCCMode'
            ])

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * onChange_viaFlight_Departure()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_viaFlight_Departure: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_ViaFlight.vue >>> onChange_viaFlight_Departure');
                if (Vue.prototype.$isEmpty(me.data[this.leg].input_viaFlight_AirportDeparture)) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof this.data[this.leg].input_viaFlight_AirportDeparture !== 'object') {
                    airport = this.get_Airports.find(airport => airport.iataCode === this.data[this.leg].input_viaFlight_AirportDeparture.toUpperCase());
                } else {
                    airport = this.get_Airports.find(airport => airport.iataCode === this.data[this.leg].input_viaFlight_AirportDeparture.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    this.data[this.leg].input_viaFlight_AirportDeparture = airport;
                } else {
                    this.data[this.leg].input_viaFlight_AirportDeparture = '';
                }


                // trigger prop
                me.onChange_viaFlight_AirportDeparture(this.data[this.leg].input_viaFlight_AirportDeparture);

            }, // eo function onChange_viaFlight_Departure()


            /*******************************************************************
            * onChange_viaFlight_AirportVia()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_viaFlight_AirportVia: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_ViaFlight.vue >>> onChange_viaFlight_AirportVia');
                if (Vue.prototype.$isEmpty(me.data[this.leg].input_viaFlight_AirportVia === null)) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof this.data[this.leg].input_viaFlight_AirportVia !== 'object') {
                    airport = this.get_Airports.find(airport => airport.iataCode === this.data[this.leg].input_viaFlight_AirportVia.toUpperCase());
                } else {
                    airport = this.get_Airports.find(airport => airport.iataCode === this.data[this.leg].input_viaFlight_AirportVia.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    this.data[this.leg].input_viaFlight_AirportVia = airport;
                } else {
                    this.data[this.leg].input_viaFlight_AirportVia = '';
                }

            }, // eo function onChange_viaFlight_AirportVia()


            /*******************************************************************
            * onChange_viaFlight_Destination()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_viaFlight_Destination: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_ViaFlight.vue >>> onChange_viaFlight_Destination');
                if (Vue.prototype.$isEmpty(this.data[this.leg].input_viaFlight_AirportDestination)) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof this.data[this.leg].input_viaFlight_AirportDestination !== 'object') {
                    airport = this.get_Airports.find(airport => airport.iataCode === this.data[this.leg].input_viaFlight_AirportDestination.toUpperCase());
                } else {
                    airport = this.get_Airports.find(airport => airport.iataCode === this.data[this.leg].input_viaFlight_AirportDestination.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    this.data[this.leg].input_viaFlight_AirportDestination = airport;
                } else {
                    this.data[this.leg].input_viaFlight_AirportDestination = '';
                }


                // trigger prop function
                me.onChange_viaFlight_AirportDestination(this.data[this.leg].input_viaFlight_AirportDestination);

            }, // eo function onChange_viaFlight_Destination()

            /*******************************************************************
            * onChange_deleteForAll
            *
            * Desc:
            * Note:
            *
            */
            onChange_deleteForAll: function(leg, value, type, inputName) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_DirectFlight.vue >>> onChange_deleteForAll');
                me.data[me.leg][inputName] = '';
                eventBus.$emit('markToDeleteBus', { leg: leg, type: type, value: value });

            } // eo function onChange_deleteForAll()

        } // eof methods()
        /* <<< ****************************************************************/
    };
</script>
